<template>
  <v-select
    :items="finishes"
    item-value="key"
    item-text="name"
    label="Настройки подсветки"
    dense
    hide-details
    outlined
    :menu-props="{
      bottom: true,
      offsetY: true,
      transition: 'scale-transition',
    }"
    single-line
    class="py-2 px-0"
    @change="changed"
    v-model="selected"
  >
  </v-select>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      selected: [],
      finishes: [
        { key: "", name: "" },
        { key: "F", name: "Фаталити" },
        { key: "B", name: "Бруталити" },
        { key: "FB", name: "Фаталити + Бруталити" },
        { key: "FBR", name: "Фаталити + Бруталити + Без добивания" },
        { key: "R", name: "Без добивания" },
        { key: "out", name: "Победа аутсайдера" },
        { key: "fav", name: "Победа фаворита" },
        { key: "1:0", name: "П1" },
        { key: "0:1", name: "П2" },
      ],
    };
  },
  methods: {
    ...mapActions(["addHighlight"]),
    ...mapGetters(["getSettings"]),
    changed: function () {
      // console.log("Changed:" + this.selected);
      this.addHighlight({ type: "rounds", value: this.selected });
    },
  },

  created() {
    let settings = this.getSettings().highlights;
    if (settings.rounds == "") {
      return;
    }
    let value = settings.rounds;
    for (const item of this.finishes) {
      if (item.key == value) this.selected = value;
    }
  },
};
</script>

<style scoped></style>
